// extracted by mini-css-extract-plugin
module.exports = {"container":"PagePlaceholder_container__395Lh","text":"PagePlaceholder_text__sPi1z","image":"PagePlaceholder_image__1btEQ"};